<li class="menu-sa-open">
  <a routerLink="/home" routerLinkActive="active" class="menu-click">
    <span class="ico-menu-sa"><i class="fa-solid fa-house"></i></span>
    <span class="menu-text-wrap-sa">
      <span class="menu-text-sa">Home</span>
    </span>
  </a>
</li>
<li class="menu-sa-open">
  <a routerLink="/dashboard" class="menu-click" routerLinkActive="active">
    <!-- <span class="ico-menu-sa"><i class="fas fa-tachometer-alt"></i></span> -->
    <span class="ico-menu-sa"><i class="fas fa-th-large"></i></span>
    <span class="menu-text-wrap-sa">
      <span class="menu-text-sa">Dashboard</span>
    </span>
  </a>
</li>
<li class="menu-sa-open">
  <a routerLink="/device/details" class="menu-click" routerLinkActive="active">
    <span class="ico-menu-sa"><i class="fas fa-play"></i></span>
    <span class="menu-text-wrap-sa">
      <span class="menu-text-sa">Device Details</span>
    </span>
  </a>
</li>
<li class="menu-sa-open">
  <a routerLink="/notify" class="menu-click" routerLinkActive="active">
    <span class="ico-menu-sa"
      ><img src="../../../assets/images/notification.png" alt=""
    /></span>
    <span class="menu-text-wrap-sa">
      <span class="menu-text-sa">Notify Command</span>
    </span>
  </a>
</li>
<li class="menu-sa-open">
  <a routerLink="/alert" class="menu-click" routerLinkActive="active">
    <span class="ico-menu-sa"><i class="fa-solid fa-bell"></i></span>
    <span class="menu-text-wrap-sa">
      <span class="menu-text-sa">Alerts</span>
    </span>
  </a>
</li>
<li class="menu-sa-open">
  <a routerLink="/device/add" class="menu-click" routerLinkActive="active">
    <span class="ico-menu-sa"><i class="fas fa-plus-circle"></i></span>
    <span class="menu-text-wrap-sa">
      <span class="menu-text-sa">Add/Delete/Modify Devices</span>
    </span>
  </a>
</li>
<li class="menu-sa-open" *ngIf="!userValidation">
  <a routerLink="/user/list" class="menu-click" routerLinkActive="active">
    <span class="ico-menu-sa"><i class="fa-solid fa-users"></i></span>
    <span class="menu-text-wrap-sa">
      <span class="menu-text-sa">User Management</span>
    </span>
  </a>
</li>
<li class="menu-sa-open">
  <a
    routerLink="/help-and-support"
    class="menu-click unclickable"
    routerLinkActive="active"
  >
    <span class="ico-menu-sa"><i class="far fa-question-circle"></i></span>
    <span class="menu-text-wrap-sa">
      <span class="menu-text-sa">Help and Support</span>
    </span>
  </a>
</li>
